<main>
  <div class="content">
    <div class="page__title under__line">
      <h1>{{ 'AssetFamily' | translate }}</h1>
    </div>
    <section>
      <div class="page__title under__line">
        <h2>{{ 'General' | translate }}</h2>
      </div>
      <div class="form-box">
        <label for="name">{{ 'Name' | translate }}</label>
        <input pInputText id="name" type="text" placeholder="{{ 'EnterName' | translate }}" value="Family 1" />
      </div>
      <div class="form-box">
        <p class="informative">(This will auto display the what the user needs to fill out on the section below)</p>
        <label for="familyType">Family Type</label>
        <p-select id="familyType" optionLabel="name" optionValue="value" [options]="familyTypes" />
      </div>
      <div class="form-box">
        <label for="">Description</label>
        <textarea pTextarea name="" id="" cols="40" rows="5" value="Description for the family"></textarea>
      </div>
    </section>
    <section>
      <div class="page__title under__line">
        <h2>Knitting Info</h2>
      </div>
      <div class="row">
        <div class="form-box">
          <label for="dia">{{ 'Dia' | translate }}</label>
          <input pInputText id="dia" type="text" placeholder="{{ 'EnterDia' | translate }}" value="30" />
        </div>
        <div class="form-box">
          <label for="gauge">{{ 'Gauge' | translate }}</label>
          <input pInputText id="gauge" type="text" placeholder="{{ 'EnterGauge' | translate }}" value="18" />
        </div>
        <div class="form-box">
          <label for="needles">{{ 'Needles' | translate }}</label>
          <input pInputText id="needles" type="text" placeholder="{{ 'EnterNeedles' | translate }}" value="3360" />
        </div>
        <div class="form-box">
          <label for="feeders">{{ 'Feeders' | translate }}</label>
          <input pInputText id="feeders" type="text" placeholder="{{ 'EnterFeeders' | translate }}" value="60" />
        </div>
        <div class="form-box">
          <label for="yarnTension">{{ 'YarnTension' | translate }}</label>
          <input pInputText id="yarnTension" type="text" placeholder="{{ 'EnterYarnTension' | translate }}" value="10" />
        </div>
        <div class="form-box">
          <label for="machineRev">{{ 'MachineRev' | translate }}</label>
          <input pInputText id="machineRev" type="text" placeholder="{{ 'EnterMachineRev' | translate }}" value="2873" />
        </div>
        <div class="form-box">
          <label for="machineRotation">Machine Rotation</label>
          <input pInputText type="text" id="machineRotation" name="machineRotation" value="Anti Clock" />
        </div>
        <div class="form-box">
          <label for="rpm">{{ 'RPM' | translate }}</label>
          <input pInputText id="rpm" type="text" placeholder="{{ 'EnterRPM' | translate }}" value="20" />
        </div>
      </div>
    </section>
  </div>
</main>
